import { DateRange, UTC }                   from 'rewire-common';
import infoPanelShiftViewModel, {
  IInfoPanelShiftViewModelChangeHandler,
  IShiftInfo,
}                                           from './InfoPanelShiftViewModel';
import { timeOffRequestReturnSchema }       from '../timeoff/TimeOffModel';
import { InfoPanelTimeOffRequestViewModel } from '../timeoff/InfoPanelTimeOffRequestViewModel';
import {
  ITimeOffRequest,
  TimeOffRequestFilterInput,
}                                           from '../DataTypes';
import DataQueries                          from '../graphql/Queries';

export class InfoPanelShiftTimeOffRequestViewModel extends InfoPanelTimeOffRequestViewModel implements IInfoPanelShiftViewModelChangeHandler {
  constructor() {
    super();
  }

  get currentInnerShift(): IShiftInfo | undefined {
    return infoPanelShiftViewModel.currentInnerShift;
  }

  get earnedDate(): UTC {
    return infoPanelShiftViewModel.earnedDate;
  }

  async load() {
    const currentShiftAbsenceDetailsWithEmployees = this.currentInnerShift?.details.filter(d => d.employee && d.reason?.category === 'absence');
    const timeOffRequests: ITimeOffRequest[]      = [];
    if (currentShiftAbsenceDetailsWithEmployees?.length) {
      const dateRange   = new DateRange(this.earnedDate, this.earnedDate);
      const employeeIds = [] as string[];
      const reasonIds   = [] as string[];
      currentShiftAbsenceDetailsWithEmployees.forEach(ad => {
        employeeIds.push(ad.employee!.id);
        reasonIds.push(ad.reason!.id);
      });
      const filters = {
        employeeIds: [...new Set(employeeIds)],
        reasonIds:   [...new Set(reasonIds)],
        custom:      [{field: 'status', in: ['approved', 'published']}],
      } as TimeOffRequestFilterInput;
      const matchingTimeOffRequests = (await DataQueries.getTimeOffRequests(timeOffRequestReturnSchema, dateRange, filters))?.data as ITimeOffRequest[];
      timeOffRequests.push(...matchingTimeOffRequests);
    }

    super.load(timeOffRequests.length ? timeOffRequests : undefined);
  }

  onCurrentInnerShiftChange() {
    this.load();
  }
}

const infoPanelShiftTimeOffRequestViewModel = new InfoPanelShiftTimeOffRequestViewModel();
export default infoPanelShiftTimeOffRequestViewModel;
